import ListUserContainer from '../../containers/ListUsersContainer'

function Users() {
  return <ListUserContainer />;
}

export default Users;